import { useEffect } from 'react';

import { Output, SourceBase, WebSocketResponseByType, WebSocketResponseTypes } from 'types';

import { socketConnection } from '../contexts/WebSocketContext';

type EventUpdateDetails = WebSocketResponseByType<WebSocketResponseTypes.EVENT_UPDATES>;

export const useEventUpdated = (
  eventId: string,
  onUpdate: (sources?: SourceBase[], outputs?: Output[]) => void
): void => {
  useEffect(() => {
    const handleMessage = (data) => {
      try {
        const {
          type,
          details: { eventId: wsEventId, sources, outputs },
        } = JSON.parse(JSON.stringify(data)) as EventUpdateDetails;
        if (type === WebSocketResponseTypes.EVENT_UPDATES && eventId === wsEventId)
          onUpdate(sources, outputs);
      } catch (err) {}
    };

    socketConnection.on('message', handleMessage);

    return () => {
      socketConnection.off('message', handleMessage);
    };
  }, [eventId]);
};
